const jobColumnDefs = [
  {
    headerName: 'Job Name',
    field: 'name',
    width: 200,
    cellRenderer: function(params) {
      const model = params.data;
      return `<div><a href="/renderings/${model._id}">${model.name}</a></div>`;
    },
    enableRowGroup: true,
  },
  { headerName: 'Type', field: 'type', width: 90, enableRowGroup: true },
  { headerName: 'Render Type', field: 'renderType', enableRowGroup: true },
  {
    headerName: 'User',
    field: 'user',
    width: 100,
    enableRowGroup: true,
  },
  {
    headerName: 'CPU Hours',
    field: 'CPUTime',
    width: 90,
    enableValue: true,
    enablePivot: true,
  },
  {
    headerName: 'Started At',
    field: 'createdAt',
    width: 110,
    filter: 'agDateColumnFilter',
    filterParams: { comparator: dateComparator },
  },
  {
    headerName: 'Finished At',
    field: 'finishedAt',
    width: 110,
    filter: 'agDateColumnFilter',
    filterParams: { comparator: dateComparator },
  },
  {
    headerName: 'Status',
    field: 'status',
    width: 90,
    enableValue: true,
    enablePivot: true,
  },
  {
    headerName: 'Date',
    hide: true,
    field: 'date',
    pivot: true,
  },
];

function dateComparator(filterDate, value) {
  if (!value) return 0;
  const year = new Date(value).getFullYear();
  const month = new Date(value).getMonth();
  const day = new Date(value).getDate();
  const cellDate = new Date(year, month, day);
  if (cellDate.getTime() < filterDate.getTime()) {
    return -1;
  } else if (cellDate.getTime() > filterDate.getTime()) {
    return 1;
  } else {
    return 0;
  }
}

export const gridOptions = {
  defaultColDef: {
    sortable: true,
    resizable: true,
    filter: true,
  },
  rowData: null,
  rowSelection: 'multiple',
  components: {
    rowNodeIdRenderer: params => Number(params.node.id) + 1,
  },
  columnDefs: jobColumnDefs,
  sideBar: true,
  pagination: true,
  statusBar: {
    items: [{ component: 'agAggregationComponent' }],
  },
  paginationPageSize: 500,
  enableRangeSelection: true,
};



// WEBPACK FOOTER //
// ./src/containers/UsageReport/lib/report.js